import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

/**
 * Override map to make it use OC Map
 */
export const overrideMap = () => {
  let map = document.querySelector("#epl-default-map");

  if (typeof google === "object" && typeof google.maps === "object") {
    if (map) {
      setTimeout(() => {
        let suburbImg = map.querySelector("img");
        let overrideImg = "/app/themes/ocre-child/media/suburb.png";

        if (suburbImg && suburbImg.src.includes("suburb")) {
          suburbImg.src = overrideImg;
        }
      }, 1500);
    }
  }
};

/**
 * Create Map cluster for maps
 * 
 * @param JSON locations 
 */
export const mapcluster = async (locations, _element = "map") => {
  // Create Loader
  const loader = new Loader({
    apiKey: "AIzaSyC--dZFvcPFXUur0xrNYr4yNI7YzxuA_Z0",
    version: "weekly"
  });

  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    "marker"
  );

  const map = new Map(document.getElementById(_element), {
    zoom: 10,
    center: { lat: -34.92123, lng: 138.599503 }, //adelaide
    mapId: "c5ea0a8e5f3c2343"
  });

  const icon = {
    url: "/app/themes/ocre-child/media/pin.svg",
    scaledSize: new google.maps.Size(30, 56), // scaled size
    origin: new google.maps.Point(0, 0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };

  let img = document.createElement("img");
  img.src = icon.url;

  const infoWindow = new InfoWindow({
    content: "",
    disableAutoPan: true
  });

  const renderer = {
    render: function({ count, position }) {
      return new google.maps.Marker({
        label: {
          text: count.toString(),
          color: "white",
          fontSize: "12px",
          height: "50px",
          width: "50px"
        },
        position,
        icon: "https://ocre.com.au/app/themes/ocre-child/media/m3.png",
        height: 50,
        width: 50
      });
    }
  };

  var markers = locations.map(function(location, i) {
    var marker = new google.maps.Marker({
      position: {
        lat: parseFloat(location["lat"]),
        lng: parseFloat(location["lng"])
      },
      icon: icon
    });

    google.maps.event.addListener(marker, "click", function(evt) {
      infoWindow.setContent(unescape(location["property_id"]));
      infoWindow.open(map, marker);
    });
    return marker;
  });

  var markerCluster = new MarkerClusterer({
    map,
    markers,
    renderer: renderer
  });
};

/**
 * Create Map cluster for maps
 * 
 * @param JSON locations 
 */
export const mapcluster_hostaway = async (locations, _element = "map") => {
  let currentInfoWindow = null;

  // Create Loader
  const loader = new Loader({
    apiKey: "AIzaSyC--dZFvcPFXUur0xrNYr4yNI7YzxuA_Z0",
    version: "weekly"
  });

  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    "marker"
  );

  const map = new Map(document.getElementById(_element), {
    zoom: 10,
    center: { lat: -34.92123, lng: 138.599503 }, //adelaide
    mapId: "c5ea0a8e5f3c2343"
  });

  const icon = {
    url: "/app/themes/ocre-child/media/pin.svg",
    scaledSize: new google.maps.Size(30, 56), // scaled size
    origin: new google.maps.Point(0, 0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };

  let img = document.createElement("img");
  img.src = icon.url;

  const infoWindow = new InfoWindow({
    content: "",
    disableAutoPan: true
  });

  const renderer = {
    render: function({ count, position }) {
      return new google.maps.Marker({
        label: {
          text: count.toString(),
          color: "white",
          fontSize: "12px",
          height: "50px",
          width: "50px"
        },
        position,
        icon: "https://ocre.com.au/app/themes/ocre-child/media/m3.png",
        height: 50,
        width: 50
      });
    }
  };

  var markers = locations.map(function(location, i) {
    var content = "";
    var features = [];
    var marker = new google.maps.Marker({
      position: {
        lat: parseFloat(location["lat"]),
        lng: parseFloat(location["lng"])
      },
      icon: icon
    });

    content += '<div class="hostaway-map-info">';

    if (location["listingImages"][0]["url"]) {
      content +=
        '<img src="' +
        location["listingImages"][0]["url"] +
        '" class="img-fluid w-100 mw-100">';
    }
    content += '<div class="p-3">';
    content += '<h6 class="mb-2">' + location["name"] + "</h6>";
    content +=
      '<p class="small">' +
      location["city"] +
      ", " +
      location["country"] +
      "</p>";

    // Add features to the array
    if (location["roomType"]) {
      let roomType = location["roomType"]
        .replace(/_/g, " ")
        .replace(/\b\w/g, char => char.toUpperCase());
      features.push(roomType);
    }
    if (location["personCapacity"] > 0)
      features.push(
        location["personCapacity"] +
          " Guest" +
          (location["personCapacity"] > 1 ? "s" : "")
      );
    if (location["bedsNumber"] > 0)
      features.push(
        location["bedsNumber"] +
          " Bed" +
          (location["bedsNumber"] > 1 ? "s" : "")
      );
    if (location["bathroomsNumber"] > 0)
      features.push(
        location["bathroomsNumber"] +
          " Bath" +
          (location["bathroomsNumber"] > 1 ? "s" : "")
      );

    const currency =
      location.currencyCode === "AUD" ? "A$" : location.currencyCode;

    const htmlContent = `
      <p class="small">${features.join(" | ")}</p>
      <p class="small"></p>
      <p class="small text-oc-gray mb-2">Price per night</p>
      <h6 class="mb-1">${currency} ${location.price}</h6>
      <p class="small text-oc-gray">Additional charges may apply</p>
      <a href="https://ocshortstays.ocre.com.au/listings/${location.id}" 
         class="btn btn-primary btn-sm" 
         target="_blank">
         View Deal
      </a>
      </div>
      </div>
    `;

    content += htmlContent;

    google.maps.event.addListener(marker, "click", function(evt) {
      if (currentInfoWindow) {
        currentInfoWindow.close();
      }

      var customInfoWindow = new google.maps.InfoWindow({
        content: content,
        disableAutoPan: true // Disable auto panning to remove the close button
      });

      customInfoWindow.open(map, marker);
      currentInfoWindow = customInfoWindow;

      // Get the current position of the marker
      var markerPosition = marker.getPosition();

      // Calculate the new center position of the map
      var mapHeight = map.getDiv().offsetHeight;
      var scale = Math.pow(2, map.getZoom());
      var worldCoordinateCenter = map
        .getProjection()
        .fromLatLngToPoint(markerPosition);
      var pixelOffset = new google.maps.Point(0, -mapHeight / 3 / scale); // Adjust to keep marker visible
      var worldCoordinateNewCenter = new google.maps.Point(
        worldCoordinateCenter.x,
        worldCoordinateCenter.y + pixelOffset.y
      );
      var newCenter = map
        .getProjection()
        .fromPointToLatLng(worldCoordinateNewCenter);

      // Animate the movement to the new center position
      map.panTo(newCenter);
    });

    return marker;
  });

  var markerCluster = new MarkerClusterer({
    map,
    markers,
    renderer: renderer
  });

  console.log(AdvancedMarkerElement);
};
